import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
    const navigate = useNavigate();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: 2 }}>
            <Typography variant="h1" sx={{ fontWeight: 800, color: '#1a1a2e' }}>404</Typography>
            <Typography variant="h6">Page introuvable</Typography>
            <Button variant="contained" onClick={() => navigate('/')}>Retour à l'accueil</Button>
        </Box>
    );
}